<template><div><h1 id="op-buchungsjournal-nach-filter" tabindex="-1"><a class="header-anchor" href="#op-buchungsjournal-nach-filter"><span>OP-Buchungsjournal nach Filter</span></a></h1>
<p>OP-Buchungsjournal nach Filter — Liste aus allen OP, die erweiterten Filterkriterien entsprechen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste aus allen OP, die erweiterten Filterkriterien entsprechen (siehe Parameter). Sie dient der Suche nach einzelnen offenen Posten. Sortierung des Outputs nach Personen-ID, Fakturanummer oder Valutadatum. Entsprechend der Sortierung können Saldi pro Adresse, Faktura oder Datum ausgewiesen werden. Die Anzeige einzelner Buchungen kann unterdrückt werden.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → OP-Kontoauszüge → OP-Buchungsjournal nach Filter</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Faktura von:</dt>
<dd>von Fakturanummer, leer = unbegrenzt, inklusive</dd>
<dt>bis:</dt>
<dd>bis Fakturanummer</dd>
<dt>Personen-ID von:</dt>
<dd>von Personen-ID, leer = unbegrenzt, inklusive</dd>
<dt>bis:</dt>
<dd>bis Personen-ID</dd>
<dt>von Betrag:</dt>
<dd>Buchungsbetrag von, 0/? = unbegrenzt, inklusive</dd>
<dt>bis:</dt>
<dd>Buchungsbetrag bis</dd>
<dt>von Valutadatum:</dt>
<dd>von Datum, ? = unbegrenzt, inklusive</dd>
<dt>bis:</dt>
<dd>bis Datum</dd>
<dt>Adressen mit Merkmal:</dt>
<dd>nur Adressen mit eingegebenem Merkmal berücksichtigen</dd>
<dt>OP-Typen:</dt>
<dd>nur Typen, mit Kommas trennen, mit ! ausschliessen, * alles</dd>
<dt>Habenkonti:</dt>
<dd>nur Konti, mit Kommas trennen, mit ! ausschliessen, * alles</dd>
<dt>erfasst durch:</dt>
<dd>nur bei Erfassungsmodus manuell, Erfasser: mit Kommas trennen, mit ! ausschliessen, * alles</dd>
<dt>Buchungen mit Ereignis:</dt>
<dd>nur Buchungen mit Ereignis anzeigen</dd>
<dt>Sortierung nach:</dt>
<dd>Sortierung nach Personen-ID, Fakturanummer, Valutadatum</dd>
<dt>Teilsaldo:</dt>
<dd>Teilsaldo anzeigen, abhängig von Sortierung</dd>
<dt>detaillierte Buchungen:</dt>
<dd>detaillierte OP-Liste anzeigen: ja/nein</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Info-Felder:</td>
<td>Rekapitulation der Parameter</td>
</tr>
<tr>
<td>Spalten:</td>
<td>Spalten:</td>
</tr>
<tr>
<td>Adresse</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Faktura</td>
<td>Fakturanummer</td>
</tr>
<tr>
<td>Typ</td>
<td>Buchungstyp + Beschreibung</td>
</tr>
<tr>
<td>Betrag</td>
<td>Buchungsbetrag</td>
</tr>
<tr>
<td>Währung</td>
<td>Währung</td>
</tr>
<tr>
<td>Ereignis</td>
<td>Ereignis mit Position</td>
</tr>
<tr>
<td>Valutadatum</td>
<td>Buchungsdatum</td>
</tr>
<tr>
<td>Konto</td>
<td>Habenkonto der Buchung</td>
</tr>
<tr>
<td>Kostenstelle</td>
<td>Kostenstelle der Buchung</td>
</tr>
<tr>
<td>Kostenträger</td>
<td>Kostenträger der Buchung</td>
</tr>
<tr>
<td>Mandant</td>
<td>Buchungsmandant</td>
</tr>
<tr>
<td>Erfasser</td>
<td>Erfasser der Buchung</td>
</tr>
</tbody>
</table>
</div></template>


